import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    OnInit
} from '@angular/core';
import {CurrentUser} from '@common/auth/current-user';
import {LinkUsageService} from '../../../shared/link/link-usage.service';
import {Toast} from '@common/core/ui/toast.service';
import {ActivatedRoute} from '@angular/router';
import {Messages} from '../../../messages.enum';
import {BackendErrorResponse} from '@common/core/types/backend-error-response';
import {HttpErrors} from '@common/core/http/errors/http-errors.enum';
import {DatatableService} from '@common/datatable/datatable.service';
import {TrackingPixelService} from '../tracking-pixel.service';
import {TrackingPixel} from '../tracking-pixel';
import {CrupdateTrackingPixelModalComponent} from '../crupdate-tracking-pixel-modal/crupdate-tracking-pixel-modal.component';
import { Observable, Subscription } from 'rxjs';
import { TRACKING_PIXEL_FILTERS } from './tracking-pixel-filters';
import { WorkspacesService } from '@common/workspaces/workspaces.service';
import { ActiveAppSectionService } from '../../active-app-section.service';
import { CUSTOM_PAGE_FILTERS } from '@common/pages/custom-pages-index/cusomt-page-filters';

@Component({
    selector: 'tracking-pixel-index',
    templateUrl: './tracking-pixel-index.component.html',
    styleUrls: ['./tracking-pixel-index.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [DatatableService],
})
export class TrackingPixelIndexComponent implements OnInit, OnDestroy {
    filters = TRACKING_PIXEL_FILTERS;
    pixels$ = this.datatable.data$ as Observable<TrackingPixel[]>;
    private workspaceSub: Subscription;

    constructor(
        public datatable: DatatableService<TrackingPixel>,
        public currentUser: CurrentUser,
        private linkUsage: LinkUsageService,
        private trackingPixels: TrackingPixelService,
        private toast: Toast,
        private route: ActivatedRoute,
        private workspaces: WorkspacesService,
        private activeSection: ActiveAppSectionService
    ) {}

    ngOnInit() {
        this.workspaceSub = this.workspaces.activeId$.subscribe(() => {
            this.setFilters();
        });
        this.datatable.init({
            uri: TrackingPixelService.BASE_URI,
            staticParams: {
                with: ['user'],
                userId: !this.showUserColumn()
                    ? this.currentUser.get('id')
                    : null,
            },
        });
    }

    ngOnDestroy() {
        this.workspaceSub.unsubscribe();
    }

    maybeDeleteSelectedPixels(pixelIds?: number[]) {
        this.datatable
            .confirmResourceDeletion('tracking pixels')
            .subscribe(() => {
                this.trackingPixels
                    .delete(pixelIds || this.datatable.selectedRows$.value)
                    .subscribe(
                        () => {
                            this.datatable.reset();
                            this.linkUsage.reload();
                            this.toast.open(
                                Messages.TRACKING_PIXEL_DELETE_SUCCESS
                            );
                        },
                        (errResponse: BackendErrorResponse) => {
                            this.toast.open(
                                errResponse.message || HttpErrors.Default
                            );
                        }
                    );
            });
    }

    showCrupdatePixelModal(pixel?: TrackingPixel) {
        this.datatable
            .openCrupdateResourceModal(CrupdateTrackingPixelModalComponent, {
                pixel,
            })
            .subscribe(() => {
                this.linkUsage.reload();
            });
    }

    showUserColumn(): boolean {
        // show in admin and if active workspace is not personal
        return this.activeSection.admin || !!this.workspaces.activeId$.value;
    }

    private setFilters() {
        this.filters = TRACKING_PIXEL_FILTERS.filter(
            f => f.key !== 'user_id' || this.showUserColumn()
        );
    }
}
